import type { PurchaseNotice } from '../types/product';

/**
 * Notifiche di acquisto mostrate nell'avviso flotante.
 * IMPORTANTE: sostituire con acquisti reali e verificabili prima della pubblicazione.
 * Nell'UE le notifiche di acquisto inventate sono considerate pratiche commerciali ingannevoli.
 */
export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Giulia', location: 'Milano', timeAgo: '3 minuti fa' },
  { name: 'Francesca', location: 'Roma', timeAgo: '7 minuti fa' },
  { name: 'Laura', location: 'Torino', timeAgo: '12 minuti fa' },
  { name: 'Chiara', location: 'Bologna', timeAgo: '18 minuti fa' },
  { name: 'Elena', location: 'Firenze', timeAgo: '25 minuti fa' },
  { name: 'Sara', location: 'Napoli', timeAgo: '34 minuti fa' },
];
